// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import { useWindowSize } from '@ion/components';

const HEADERS_HEIGHT = 300;

export default function useAppMainHeight() {
  const windowSize = useWindowSize();
  return `${windowSize.height - HEADERS_HEIGHT}px`;
}
